import { createAction, props } from '@ngrx/store';
import { subscribersListPayload } from './subscriber.model';

export const fetchSubscribersList = createAction('[Data] Fetch Subscribers List', props<{ payload: subscribersListPayload }>());
export const fetchSubscribersListSuccess = createAction('[Data] Fetch Subscribers List Success', props<{ response: any }>());
export const fetchSubscribersListFailure = createAction('[Data] Fetch Subscribers List Failure', props<{ error: string }>());
